import * as React from "react";

import { Label } from "simplydo/react/ui/label";
import { TableCell } from "simplydo/react/ui/table";

import { invoke } from "../../lib/utils";
import type { OnValueClickData } from "../BaseCalendarView";

const hoverCellStyles = { outline: "1px solid #85b7d9", cursor: "pointer" };

export interface CellWidthStyle {
  width: string;
}

interface CellProps {
  /** Position of a cell on the page. (Used by parent component) */
  itemPosition: number;
  /** Cell's content. */
  children: string;
  /** Styles for cell width. */
  style: CellWidthStyle;
  /** Called after click on a cell. */
  onClick: (
    e: React.SyntheticEvent<HTMLElement>,
    data: OnValueClickData,
  ) => void;
  /** Called on cell hover. */
  onHover: (
    e: React.SyntheticEvent<HTMLElement>,
    data: OnValueClickData,
  ) => void;
  /** Is cell is hovered. */
  hovered?: boolean;
  /** Is cell active. */
  active?: boolean;
  /** Is cell disabled. */
  disabled?: boolean;
  /** Is cell marked. */
  marked?: boolean;
  /** Color of the mark. */
  markColor?: any;
}

class Cell extends React.Component<CellProps, any> {
  public render() {
    const {
      itemPosition,
      children,
      style,
      onClick,
      onHover,
      hovered,
      marked,
      markColor,
      ...rest
    } = this.props;

    const cellStyle = { ...style, ...(hovered ? hoverCellStyles : {}) };

    return (
      <TableCell
        {...rest}
        style={cellStyle}
        onMouseOver={this.onCellHover}
        onClick={this.onCellClick}
      >
        {marked && !rest.disabled ? (
          <Label circular color={markColor} key={children}>
            {children}
          </Label>
        ) : (
          <span className="suicr-content-item">{children}</span>
        )}
      </TableCell>
    );
  }

  private onCellClick = (event: React.SyntheticEvent<HTMLElement>) => {
    const { itemPosition, children } = this.props;
    invoke(this.props, "onClick", event, {
      ...this.props,
      itemPosition,
      value: children,
    });
  };

  private onCellHover = (event: React.SyntheticEvent<HTMLElement>) => {
    const { itemPosition } = this.props;
    invoke(this.props, "onHover", event, { ...this.props, itemPosition });
  };
}

export default Cell;
